import { AuthRoutes } from "./AuthRoutes";
import { DashboardRoutes } from "./DashboardRoutes";
import { ProfileRoutes } from "./ProfileRoutes";
import Privacy from "../Pages/privacy";
import FAQ from "../Pages/PublicPages/Faq/Faq";
import PageNotFound from "../Pages/PageNotFound";
import Terms from "../Pages/PublicPages/Terms/Terms";
import ContactUs from "../Pages/PublicPages/ContactUs/ContactUs";
import AboutUs from "../Pages/PublicPages/Aboutus/Aboutus";

const routes = [
  ...DashboardRoutes,
  ,
  // ...AuthRoutes,
  ...ProfileRoutes,

  // {
  //   path: "/dashboard",
  //   component: Dashboard,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/on-Boarding",
  //   component: OnBoard,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/maintenance",
  //   component: Maintainance,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/addScheduler",
  //   component: AddSchedular,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/timeSlot",
  //   component: TimeSlot,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/users",
  //   component: ManageUser,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/add-user",
  //   component: AddUser,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/add-permission",
  //   component: AddPermission,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/permissions",
  //   component: ManagePermission,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/allow-permission",
  //   component: AddPermssionForRole,
  //   private: true,
  //   exact: true,
  // },

  {
    path: "/Aboutus",
    component: AboutUs,
    ispublic: true,
    exact: true,
  },
  {
    path: "/terms",
    component: Terms,
    ispublic: true,
    exact: true,
  },
  {
    path: "/contact-us",
    component: ContactUs,
    ispublic: true,
    exact: true,
  },
  {
    path: "/privacy",
    component: Privacy,
    ispublic: true,
    exact: true,
  },
  {
    path: "/faq",
    component: FAQ,
    ispublic: true,
    exact: true,
  },
  // {
  //   path: "/notes",
  //   component: Notes,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/calendar",
  //   component: Calendar,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/all-listing",
  //   component: EventListing,
  //   private: true,
  //   exact: true,
  // },

  // {
  //   path: "/add-staff/:id",
  //   component: AddStaff,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/add-provider/:id",
  //   component: AddProvider,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/staff-list",
  //   component: StaffList,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/all-customer",
  //   component: CustomerList,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/staff-profile-view/:id",
  //   component: StaffListView,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/all-customer/columns-list",
  //   component: CustomerColumnList,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/staff-list/:id/columns-list",
  //   component: StaffColumnList,
  //   private: true,
  //   exact: true,
  // },

  // {
  //   path: "/providerScheduler/:id",
  //   component: ProvidersList,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/providerSchedulerViewer/:id",
  //   component: ProviderSchedular,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/addScheduler",
  //   component: AddSchedularCalendar,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/timeSlots",
  //   component: SchedularTimeSlots,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/form_creation",
  //   component: FormCreation,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/payment-list",
  //   component: PaymentList,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/answer-page",
  //   component: AnswerPage,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/our-faculty",
  //   component: FacultyPage,
  //   private: true,
  //   exact: true,
  // },
  // {
  //   path: "/edit-faculty",
  //   component: EditFaculty,
  //   private: true,
  //   exact: true,
  // },
  {
    path: "*",
    component: PageNotFound,
    private: true,
  },
];
export default routes;

// import AddAdvisor from "../Pages/AdminPages/addAdviser";
// import AdviserList from "../Pages/AdminPages/Advisor/Advisor";
// import ViewProfileAdmin from "../Pages/AdminPages/ViewprofileAdmin/ViewprofileAdmin";
// import Advisor from "../Pages/PublicPages/Advisor/Advisor";
// import DashboardAdmin from "../Pages/AdminPages/DashboardAdmin/DashboardAdmin";
// import ConfirmMail from "../Pages/Seller/Pages/ConfirmMail/ConfirmMail";
// import StartUp from "../Pages/Seller/Pages/Startup/Startup";
// import MyListing from "../Pages/Seller/Pages/Mylisting/Mylisting";
// import CreateProfile from "../Pages/Seller/Pages/Createprofile/Createprofile";
// import ChangePassword from "../Pages/AdminPages/Changepassword/Changepassword";
// import Dashboard1 from "../Pages/Dashboard/MainComponent/Maincomponent";
// import OnBoarding from "../Pages/Dashboards/onboard";
// {
//   path: "/Dashboard1",
//   component: Dashboard1,
//   private: true,
//   exact: true,
// },
// {
//   path: "/on-board/:id",
//   component: OnBoarding,
//   private: true,
//   exact: true,
// },
// {
//   path: "/advisor",
//   component: lazy(() =>
//     fakeDelay(delayTime)(import("../Pages/PublicPages/Advisor/Advisor"))
//   ),
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/addAdvisor",
//   component:AddAdvisor,
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/editAdvisor/:id",
//   component: AddAdvisor,
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/advisorListing",
//   component: AdviserList,
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/view-profile/:id",
//   component: ViewProfileAdmin,
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/Admin-Public",
//   component: Advisor,
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/Dashboard-Admin",
//   component: DashboardAdmin,
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/change-password",
//   component: ChangePassword,
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/add-business-address",
//   component: lazy(() =>
//     fakeDelay(delayTime)(import("../Pages/BusinessProfile/Business"))
//   ),
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/confirm-mail",
//   component: ConfirmMail,
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/startup",
//   component: StartUp,
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/listing",
//   component: MyListing,
//   ispublic: true,
//   exact: true,
// },
// {
//   path: "/createprofile",
//   component: CreateProfile,
//   ispublic: true,
//   exact: true,
// },
